import { render, staticRenderFns } from "./ProductsFooter.vue?vue&type=template&id=0fcb21fc&scoped=true"
import script from "./ProductsFooter.vue?vue&type=script&lang=js"
export * from "./ProductsFooter.vue?vue&type=script&lang=js"
import style0 from "./ProductsFooter.vue?vue&type=style&index=0&id=0fcb21fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb21fc",
  null
  
)

export default component.exports